import { render, staticRenderFns } from "./LoginMgn.vue?vue&type=template&id=def8b610"
import script from "./LoginMgn.vue?vue&type=script&lang=js"
export * from "./LoginMgn.vue?vue&type=script&lang=js"
import style0 from "./LoginMgn.vue?vue&type=style&index=0&id=def8b610&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports